/* eslint-disable max-len */
import Cookies from 'js-cookie';
import { useStaticQuery, graphql } from 'gatsby';

const useDiscount = ({ envoyClient, checkout }) => {
	const { wp } = useStaticQuery(
		graphql`
			{
				wp {
					globalSettings {
						acfGlobalSettings {
							affiliateLinks {
								affiliateCode
								shopifyDiscountCode
							}
						}
					}
				}
			}
		`
	);
	const affiliateCodesWP = wp.globalSettings.acfGlobalSettings.affiliateLinks;

	const applyDiscount = async(checkoutID, discountCode) => {
		if (!checkout.lineItems.length || checkout.discountCodes.length) return;

		const res = await envoyClient.cart.updateDiscountCodes(checkoutID, [discountCode]);

		if (res?.userErrors?.length) {
			window.console.error(res?.userErrors);
			throw res.userErrors;
		}
		return res;
	};

	const removeDiscount = async checkoutID => {
		if (Cookies.get('affiliate')) {
			Cookies.set('affiliate', 'expired', {domain: process.env.GATSBY_COOKIE_DOMAIN});
		}
		if (!checkout.discountCodes.length || !checkout.lineItems.length) return;

		const res = await envoyClient.cart.updateDiscountCodes(checkoutID, []);

		if (res?.userErrors?.length) {
			window.console.error(res?.userErrors);
			throw res.userErrors;
		}
		return res;
	};

	const updateCheckoutDiscount = async() => {
		try {
			const cookieAffiliate = Cookies.get('affiliate') || 'null';

			// apply/remove discounts
			if (cookieAffiliate === 'null' || cookieAffiliate === 'expired') {
				return removeDiscount(checkout.id);
			}
			const codeDetails = affiliateCodesWP.find(code => {
				return cookieAffiliate === code.affiliateCode;
			});
			if (!codeDetails) return removeDiscount(checkout.id);
			return applyDiscount(checkout.id, codeDetails.shopifyDiscountCode, codeDetails.affiliateCode);
		} catch (error) {
			window.console.error('Error in updateCheckoutDiscount:', error);
			throw error;
		}
	};

	return {
		updateCheckoutDiscount,
	};
};

export default useDiscount;
